import { PostHogConfig } from 'posthog-js';

export const APP_TITLE = 'CamuHealth';
export const APP_ENV: 'develop' | 'staging' | 'production' =
  import.meta.env.VITE_APP_ENV || 'develop';

export const DEFAULT_PAGINATION_SIZE = 20;

export const STRIPE_PUBLISHABLE_KEY: string = import.meta.env
  .VITE_STRIPE_PUBLISHABLE_KEY;

export const LOOM_TUTORIAL_VIDEOS_URL =
  'https://loom.com/share/folder/9572c76c3e4640d5b9678e62d2736922';

export const IS_REPORTING_ENABLED =
  import.meta.env.VITE_IS_REPORTING_ENABLED ?? APP_ENV === 'production';

export const SUPPORT_EMAIL =
  import.meta.env.VITE_SUPPORT_EMAIL || 'support@camuhealth.com';

const isDev = APP_ENV === 'develop';
export const POSTHOG_OPTIONS: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-11-30',
  capture_exceptions: !isDev,
  disable_session_recording: isDev,
  debug: isDev
};
